import React from 'react';

import { FormattedMessage } from 'react-intl';

import { Button, Hr } from '@shared/components';

import styles from './SingleReport.less';

interface SingleReportDesktopProps {
  name: string | React.ReactNode;
  description?: string;
  onClick: () => void;
  noDivider?: boolean;
  openLabel?: string | React.ReactNode;
}

const SingleReportDesktop: React.FC<SingleReportDesktopProps> = ({
  name,
  description,
  openLabel,
  noDivider,
  onClick,
}) => (
  <React.Fragment>
    <div className={styles.singleReport}>
      <span className={styles.name}>{name}</span>
      <span className={styles.description}> {description} </span>
      <span className={styles.url}>
        <Button fitText noBorder color="info" size="large" onClick={onClick}>
          {openLabel ? openLabel : <FormattedMessage id="shared.view" />}
        </Button>
      </span>
    </div>
    {!noDivider && <Hr className={styles.hr} />}
  </React.Fragment>
);

export default SingleReportDesktop;
